import { cloneDeep as lodashCloneDeep } from 'lodash'

export const cloneDeep = lodashCloneDeep
